export default __webpack_public_path__ + "static/media/consciencia_fonologica.5aab1df2.pdf";